import { axios, BaseApiUrl } from '../axios_config';

// 获取移动端按库位查询盘点数据
export const getLocationStockTakingList = params =>{
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetLocationStockTakingList`, { params }).then(res => res.data);
}

// 获取移动端按SKU查询盘点数据
export const getSKUStockTakingList = params =>{
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetProductStockTaking`, { params }).then(res => res.data);
}

// 获取移动端查询盘点库存总数
export const getStockTakingtotal = params =>{
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetStockTakingtotal`, { params }).then(res => res.data);
}

// 移动端插入盘点
export const addStockTaking = params =>{
    return axios.post(`${BaseApiUrl}/InventoryQuery/AddStockTaking`, { ...params }).then(res => res.data);
}

// 获取移动端查询SKU是否存在
export const getSkuStock = params =>{
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetProductStock`, { params }).then(res => res.data);
}

// 获取移动端SKU库存
export const getProductInventory = params =>{
    return axios.get(`${BaseApiUrl}/InventoryQuery/GetProductInventory`, { params }).then(res => res.data);
}